<template>
  <Dialog :header="$t('create_channel.createChannel')" v-model:visible="displayDialog" :modal="true">
    <div class="p-fluid">
      <div class="p-field">
        <label for="channelName">{{ $t('create_channel.channelName') }}</label>
        <InputText id="channelName" v-model="channelName" required  style="width: 100%;" />
      </div>
      <div class="p-field">
        <label for="channelDescription">{{ $t('create_channel.channelDescription') }}</label>
        <Editor id="channelDescription" v-model="channelDescription" rows="3" />
      </div>
      <div class="p-field-checkbox mt-3">
        <Checkbox inputId="autojoin" v-model="autojoin"  value="autojoin"/>
        <label for="autojoin" class="mr-2" v-if="g_settings.channel_autojoin > 0">
          {{ $t('create_channel.enableAutojoin', { cost: g_settings.channel_autojoin }) }}
        </label>
        <label for="autojoin" v-else>
          {{ $t('create_channel.enableAutojoinFree') }}
        </label>
      </div>
      <div class="p-field-checkbox mt-3">
        <Checkbox inputId="isAdult" v-model="isAdult"  value="isAdult"/>
        <label for="isAdult">
          {{ $t('create_channel.adultContentChannel') }}
        </label>
      </div>
      <div class="mb-4 mt-4" v-if="g_settings.create_channel > 0">
        <span class="font-semibold">
          {{ $t('create_channel.channelCreationCost', { cost: g_settings.create_channel }) }}
        </span>
      </div>
      <div class="p-field mt-4">
        <Button :label="$t('create_channel.create')" @click="createChannel" />
      </div>
    </div>
  </Dialog>
  <Toast />

</template>
  
  <script>

  
  export default {
    name: 'CreateChannelDialog',
    props: ['g_settings'],
    data() {
      return {
        displayDialog: false, 
        channelName: '',
        channelDescription: '',
        autojoin: false,
        isAdult: false
      };
    },
    methods: {
      createChannel() {
        if (this.channelName.length < 3) {
            this.$toast.add({ severity: 'warn', summary: this.$t('error_messages.error'), detail:  this.$t('create_channel.nameTooShort'), life: 3000 });
            return;
        }

        const newChannel = {
          name: this.channelName,
          description: this.channelDescription,
          autojoin: this.autojoin ? 1 : 0,
          isAdult: this.isAdult ? 1 : 0
        };
        this.$socket.emit('create-channel', newChannel);
      },
      showDialog() {
        this.displayDialog = true;
      },
    },
    mounted() {
      this.$socket.on('error_msg_create_channel', (data) => {
        switch (data.code) {
          case 1:
            this.$toast.add({ severity: 'error', summary: this.$t('error_messages.error'), detail:  this.$t('channel_error_messages.1'), life: 3000 });
            break;
          case 2:
            this.$toast.add({ severity: 'error', summary: this.$t('error_messages.error'), detail:  this.$t('channel_error_messages.2'), life: 3000 });
            break;
          case 3:
            this.$toast.add({ severity: 'error', summary: this.$t('error_messages.error'), detail:  this.$t('channel_error_messages.3'), life: 3000 });
            break;
          default:
            this.$toast.add({ severity: 'error', summary: this.$t('error_messages.error'), detail:  this.$t('channel_error_messages.3'), life: 3000 });
        }
      });
      this.$socket.on('channelCreated', (data) => {
        this.$socket.emit('join', {
          id: data.id,
          name: data.name,
        });
        this.displayDialog = false;
      });
    },
    beforeUnmount() {
      this.$socket.off('channelCreated');
      this.$socket.off('error_msg_create_channel');
    },
    watch: {
      autojoin(newValue) {
        if (newValue && this.isAdult) {
          this.isAdult = false;
          this.$toast.add({ severity: 'info', summary: this.$t('error_messages.info'), detail:  this.$t('create_channel.info_message'), life: 3000 });

        }
      },
      isAdult(newValue) {
        if (newValue && this.autojoin) {
          this.autojoin = false;
        }
      },
    }
  };
  </script>
  
  <style scoped>
  .p-field {
    margin-bottom: 1rem;
  }
  .p-field label {
    display: block;
    margin-bottom: 0.2rem;
  }
  </style>
  